import { Styles, generateClasses } from 'netline-ui';

export const preferencesPopupClasses = generateClasses('PreferencesPopup', ['popup'] as const);

const styles: Styles = ({
  theme: {
    palette: { common },
  },
}) => ({
  [`.${preferencesPopupClasses.popup}`]: {
    zIndex: 1001,
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: common.white,
  },
});

export default styles;
